import React from "react";

const StoreSettingsFieldRow = ({ label, help, children }) => (
  <div className="store-settings-field-row">
    <div className="store-settings-field-label">
      {label && <div className="store-settings-label-title">{label}</div>}
      {help && <p className="store-settings-label-help">{help}</p>}
    </div>
    <div className="store-settings-field-input">{children}</div>
  </div>
);

export default StoreSettingsFieldRow;
